var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2537_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2879 0.5H1.83633C0.856641 0.5 0.0644531 1.27344 0.0644531 2.22969V22.7656C0.0644531 23.7219 0.856641 24.5 1.83633 24.5H22.2879C23.2676 24.5 24.0645 23.7219 24.0645 22.7703V2.22969C24.0645 1.27344 23.2676 0.5 22.2879 0.5ZM7.18477 20.9516H3.62227V9.49531H7.18477V20.9516ZM5.40352 7.93438C4.25977 7.93438 3.33633 7.01094 3.33633 5.87187C3.33633 4.73281 4.25977 3.80937 5.40352 3.80937C6.54258 3.80937 7.46602 4.73281 7.46602 5.87187C7.46602 7.00625 6.54258 7.93438 5.40352 7.93438ZM20.516 20.9516H16.9582V15.3828C16.9582 14.0562 16.9348 12.3453 15.1066 12.3453C13.2551 12.3453 12.9738 13.7937 12.9738 15.2891V20.9516H9.4207V9.49531H12.8332V11.0609H12.8801C13.3535 10.1609 14.516 9.20938 16.2457 9.20938C19.8504 9.20938 20.516 11.5813 20.516 14.6656V20.9516Z",
    fill: "#043873"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2537_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0644531 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2fb35455d02f7ccb1ef5bbba2a68fb27.svg";
export { ForwardRef as ReactComponent };